import { render, staticRenderFns } from "./ProductCategoriyList.vue?vue&type=template&id=13ab82f4&"
import script from "./ProductCategoriyList.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoriyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports